/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDatabaseFile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m4 6 .003-.015a.296.296 0 0 1 .032-.066c.043-.07.13-.174.291-.301.33-.26.87-.539 1.626-.79C7.454 4.326 9.592 4 12 4s4.546.327 6.048.827c.756.252 1.296.53 1.626.79.162.128.249.232.29.302.021.033.03.055.033.066L20 6s0 .006-.003.015a.293.293 0 0 1-.032.066c-.042.07-.13.174-.291.301-.33.26-.87.539-1.626.79C16.546 7.674 14.408 8 12 8s-4.546-.327-6.048-.827c-.756-.252-1.296-.53-1.626-.79a1.236 1.236 0 0 1-.29-.302.296.296 0 0 1-.033-.066L4 6zm16 2.527V10h2V6c0-.852-.519-1.504-1.088-1.953-.581-.458-1.36-.826-2.232-1.117C16.925 2.345 14.563 2 12 2c-2.563 0-4.925.345-6.68.93-.873.29-1.651.66-2.232 1.117C2.518 4.496 2 5.148 2 6v12c0 .794.453 1.416.97 1.856.52.443 1.218.802 1.996 1.09 1.564.578 3.676.95 5.997 1.035l.074-1.999c-2.179-.08-4.067-.428-5.378-.912-.659-.244-1.118-.503-1.394-.738a1.067 1.067 0 0 1-.238-.263.257.257 0 0 1-.025-.056L4 18v-3.473c.301.154.626.293.966.419 1.564.578 3.676.95 5.997 1.035l.074-1.999c-2.179-.08-4.067-.428-5.378-.912-.659-.244-1.118-.503-1.394-.738a1.067 1.067 0 0 1-.238-.263A.257.257 0 0 1 4 12V8.527a9.59 9.59 0 0 0 1.32.543c1.755.585 4.117.93 6.68.93 2.563 0 4.925-.345 6.68-.93A9.536 9.536 0 0 0 20 8.527zM13 12h6.535L22 15.697V22h-9zm2 2v6h5v-3.697L18.465 14z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDatabaseFile as DatabaseFile };
